import React from "react";
import { Route, Routes } from "react-router-dom";
import Agents from "../app/AgentViews/Agents";
import AddAgent from "../app/AgentViews/Agents/AddAgent";
import AgentProfile from "../app/AgentViews/Agents/AgentProfile";
import TopUp from "../app/AgentViews/Agents/TopUp";
import AddIdentification from "../app/AgentViews/Agents/addIdentification";
import Commissions from "../app/AgentViews/Commisions";
import Dashboard from "../app/AgentViews/Dashboard";
import FundingStatement from "../app/AgentViews/FundingStatement";
import Receivers from "../app/AgentViews/Receivers";
import AddReceiver from "../app/AgentViews/Receivers/AddReceiver";
import ReceiverProfile from "../app/AgentViews/Receivers/ReceiverProfile";
import Index from "../app/AgentViews/SendMoney";
import Senders from "../app/AgentViews/Senders";
import SenderProfile from "../app/AgentViews/Senders/SenderProfile";
import Settings from "../app/AgentViews/Settings";
import Transactions from "../app/AgentViews/Transactions";
import TransactionReceipt from "../app/AgentViews/Transactions/TransactionReceipt.jsx";
import TransactionHistory from "../app/AgentViews/TransactionsHistory";
import PageNotFound from "./404Page";
import AddNewSender from "./common/AddNewSender";
import AddNewReceiver from "./common/AddNewReceiver";

const AgentRoutes = ({ setShowSidebar, setShowNavbar }) => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/transactions" element={<Transactions />} />
      <Route path="/transaction-history" element={<TransactionHistory />} />
      <Route path="/send-money" element={<Index />} />
      <Route path="/add-sender" element={<AddNewSender />} />
      <Route path="/add-agent" element={<AddAgent />} />
      <Route path="/topup/:id" element={<TopUp />} />
      <Route path="/add-receiver" element={<AddNewReceiver />} />
      <Route path="/add-identification" element={<AddIdentification />} />
      <Route path="/agents" element={<Agents />} />
      <Route path="/transaction/:id" element={<TransactionReceipt />} />
      {/* <Route path="/transaction/:id" element={<Receipt />} /> */}
      <Route path="/senders" element={<Senders />} />
      <Route path="/funding-statement" element={<FundingStatement />} />
      <Route path="/statement/:type/:id" element={<FundingStatement />} />
      <Route path="/receivers" element={<Receivers />} />
      <Route path="/receiver/:id" element={<ReceiverProfile />} />
      {/* <Route path="/receiver/:id" element={<Receiver />} /> */}
      <Route path="/sender/:id" element={<SenderProfile />} />
      {/* <Route path="/sender/:id" element={<Sender />}/> */}
      <Route path="/agent/:id" element={<AgentProfile />} />
      {/* <Route path="/agent/:id" element={<Agent />} /> */}
      <Route path="/settings" element={<Settings />} />
      <Route path="/commissions" element={<Commissions />} />
      <Route path="/commissions/:type/:id" element={<Commissions />} />
      <Route
        path="*"
        element={
          <PageNotFound
            setShowSidebar={setShowSidebar}
            setShowNavbar={setShowNavbar}
          />
        }
      />
    </Routes>
  );
};

export default AgentRoutes;
